import React from 'react';
import { XCircleIcon } from 'lucide-react';
const painPoints = ['El dinero nunca alcanza y vives contando cada peso', 'Quieres emprender pero el miedo a perder dinero te paraliza', 'Pensás en la inversión inicial y te da vértigo', 'No querés otro "cursito más" que termine juntando polvo digital', 'Ya probaste con velas, repostería... y no funcionó', 'La competencia es brutal y los precios están por el piso'];
export function PainPointsSection() {
  return <section className="bg-white py-12 md:py-16 px-4" data-id="element-81">
      <div className="container mx-auto max-w-4xl" data-id="element-82">
        <h2 className="text-3xl md:text-5xl font-extrabold text-pink-600 text-center mb-8 md:mb-12 leading-tight" data-id="element-83">
          ¿Te Suena Familiar?
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6" data-id="element-84">
          {painPoints.map((point, index) => <article key={index} className="bg-pink-50 border-4 border-rose-300 rounded-lg p-6 shadow-xl" data-id="element-85">
              <div className="flex items-start gap-4" data-id="element-86">
                <XCircleIcon className="w-8 h-8 md:w-10 md:h-10 text-rose-500 flex-shrink-0 mt-1" aria-hidden="true" data-id="element-87" />
                <p className="text-lg md:text-xl text-stone-800 font-bold leading-tight" data-id="element-88">
                  {point}
                </p>
              </div>
            </article>)}
        </div>

        <div className="mt-8 md:mt-12 text-center" data-id="element-89">
          <p className="text-xl md:text-3xl text-rose-500 font-extrabold uppercase" data-id="element-90">
            ¡Es Hora de Cambiar Esto HOY!
          </p>
        </div>
      </div>
    </section>;
}